module.exports = __webpack_public_path__ + "img/map.1bd445a0.png";